module.exports = __webpack_public_path__ + "static/media/ORBS.58d4db07.svg";